import { render, staticRenderFns } from "./m-article-single.vue?vue&type=template&id=e878b4ac"
import script from "./m-article-single.vue?vue&type=script&lang=js"
export * from "./m-article-single.vue?vue&type=script&lang=js"
import style0 from "./m-article-single.vue?vue&type=style&index=0&id=e878b4ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports